export const primaryCode =
`
  <Accordion>
    <AccordionItem>
      
    </AccordionItem>
  </Accordion>
`;

export const secondaryCode =
`
  <Accordion>
    <AccordionItem secondary>

    </AccordionItem>
  </Accordion>
`;

export const reducedSpacesCode =
`
  <Accordion>
    <AccordionItem reducedSpaces>
      
    </AccordionItem>
  </Accordion>
`;



// WEBPACK FOOTER //
// ./src/containers/components/Accordion/constants/accordionsCode.js